import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import posthog from 'posthog-js';
import api from '../../api/apiHelper';
import OrzelKsiazkaIcon from '../../img/icons/orzel_ksiazka.png';

const SURVEY_KEY = 'post_purchase';

// Dwa pytania, oba otwarte. Pierwsze daje jezyk, ktorym kupujacy sami opisuja
// zakup (material na landing i reklamy), drugie — liste blokerow, ktore w tej
// chwili kosztuja nas wszystkich, ktorzy nie kliknęli.
const Q_TRIGGER = 'Co sprawiło, że zdecydowałeś(aś) się na zakup?';
const Q_HESITATION = 'A co Cię powstrzymywało? Co prawie sprawiło, że odpuściłeś(aś)?';

const PurchaseSurveyPopup = ({ isOpen, onClose }) => {
    const [step, setStep] = useState('form'); // 'form' -> 'thanks'
    const [trigger, setTrigger] = useState('');
    const [hesitation, setHesitation] = useState('');
    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        if (isOpen) {
            posthog.capture('purchase_survey_viewed');
            setStep('form');
            setTrigger('');
            setHesitation('');
            setIsSending(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    // Zapis idzie „w tle" — popup nigdy nie zawiesza sie na sieci, bo nieudana
    // ankieta nie moze byc problemem usera, ktory wlasnie zaplacil. Backend ma
    // get_or_create, wiec ewentualny retry i tak nie zduplikuje wiersza.
    const persist = (answers) => {
        api.post('survey/submit/', { survey_key: SURVEY_KEY, answers }, { skipLoading: true })
            .catch(() => {});
    };

    const handleSubmit = () => {
        if (isSending) return;
        setIsSending(true);

        const answers = { trigger: trigger.trim(), hesitation: hesitation.trim() };
        posthog.capture('purchase_survey_submitted', answers);
        persist(answers);

        setStep('thanks');
        setTimeout(() => onClose(), 2600);
    };

    const handleSkip = () => {
        posthog.capture('purchase_survey_skipped');
        persist({ dismissed: true });
        onClose();
    };

    const canSubmit = (trigger.trim() || hesitation.trim()) && !isSending;

    return ReactDOM.createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-[9998] p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-sm w-full text-center transform animate-swoosh-in border-4 border-white ring-4 ring-white/20">

                <div className="flex justify-center mb-4">
                    <img src={OrzelKsiazkaIcon} alt="Orzeł z książką" className="w-28 h-28" />
                </div>

                {step === 'thanks' && (
                    <>
                        <h2 className="text-2xl font-apotek tracking-wider text-[#233855] mb-3 uppercase font-bold">
                            Przyjemnej nauki!
                        </h2>
                        <p className="text-gray-600 text-base leading-relaxed">
                            Powodzenia na maturze - trzymam kciuki!
                        </p>
                    </>
                )}

                {step === 'form' && (
                    <>
                        <h2 className="text-2xl font-apotek tracking-wider text-[#233855] mb-2 uppercase font-bold">
                            Dzięki za zakup!
                        </h2>
                        <p className="text-gray-600 text-sm mb-5 leading-relaxed px-2">
                            Odpowiesz na dwa krótkie pytania? Bardzo mi pomogą.
                        </p>

                        <p className="text-[#233855] mb-2 text-sm font-bold leading-snug text-left">
                            {Q_TRIGGER}
                        </p>
                        <textarea
                            value={trigger}
                            onChange={(e) => setTrigger(e.target.value)}
                            placeholder="Wystarczy jedno zdanie..."
                            className="w-full h-20 p-3 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:border-[#233855] focus:ring-1 focus:ring-[#233855] text-left mb-4 shadow-inner"
                            autoFocus
                        />

                        <p className="text-[#233855] mb-2 text-sm font-bold leading-snug text-left">
                            {Q_HESITATION}
                        </p>
                        <textarea
                            value={hesitation}
                            onChange={(e) => setHesitation(e.target.value)}
                            placeholder="Też jedno zdanie w zupełności starczy..."
                            className="w-full h-20 p-3 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:border-[#233855] focus:ring-1 focus:ring-[#233855] text-left mb-6 shadow-inner"
                        />

                        <button
                            onClick={handleSubmit}
                            disabled={!canSubmit}
                            className="w-full font-apotek tracking-widest uppercase text-sm text-white font-bold py-3 px-4 rounded-xl shadow-2xl transform transition-transform active:scale-95 bg-[#233855] hover:bg-[#1a2b42] disabled:opacity-40 disabled:cursor-not-allowed"
                        >
                            Wyślij
                        </button>

                        <button
                            onClick={handleSkip}
                            className="mt-4 w-full text-sm font-semibold text-gray-400 hover:text-gray-600 transition-colors uppercase tracking-wider py-2"
                        >
                            Nie teraz
                        </button>
                    </>
                )}
            </div>
        </div>,
        document.body
    );
};

export default PurchaseSurveyPopup;
